'use client'

import Link from 'next/link'

import { EASE, HAIRLINE, useReveal } from '@/components/page-kit'
import { Button } from '@/components/ui/button'
import { ChromaText } from '@/components/ui/chroma-text'
import { cn } from '@/lib/utils'

/* Closing CTA. The old build set the heading in text-slate-900 — invisible on
   the dark canvas — under a blurred glow orb. Tokens and the site's ChromaText
   heading fix the contrast in both themes; the primary button borrows the
   navbar CTA's arrow hand-off. */

export function CtaSection() {
  const { ref, shown } = useReveal<HTMLDivElement>(0.2)

  const handleDownloadPDF = () => {
    const link = document.createElement('a')
    link.href = '/IntelQI Product Brochure.pdf'
    link.download = 'IntelQI-Product-Brochure.pdf'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <section
      id="demo"
      className={cn('border-t bg-background py-20 md:py-28 lg:py-32', HAIRLINE)}
    >
      <div
        ref={ref}
        className="container mx-auto max-w-3xl text-center"
        style={{
          opacity: shown ? 1 : 0,
          transform: shown ? 'translateY(0)' : 'translateY(24px)',
          transition: `opacity 0.7s ${EASE}, transform 0.7s ${EASE}`,
        }}
      >
        <p className="text-[11px] font-black uppercase tracking-[0.24em] text-emerald-600 dark:text-primary-active">
          Get Started
        </p>

        <h2 className="font-heading mt-5 text-3xl font-normal leading-tight sm:text-4xl md:text-5xl">
          <ChromaText>Transform your school management today</ChromaText>
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base md:text-[17px]">
          Join schools that made the switch. No commitment, no credit card
          required.
        </p>

        <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row sm:gap-4">
          <Button asChild size="xl">
            <Link href="/schedule-meeting">Schedule a walkthrough</Link>
          </Button>

          <Button variant="outline" size="xl" onClick={handleDownloadPDF}>
            Download Brochure
          </Button>
        </div>
      </div>
    </section>
  )
}
